import CardWithShadow from "@/components/CardWithShadow";
import Text from "@/components/Text";
import Theme from "@/utils/theme";
import { Box, CircularProgress } from "@mui/material";
import Spacer from "@/components/Spacer";
import ShapedAccordion from "@/components/ShapedAccordion";
import AccordionSummary from "./components/AccordionSummary";
import AccordionDetailsList from "./components/AccordionDetailsList";
import { useChallenges } from "./useChallenges";
import { useStages } from "@/context/StagesContext";
import TotalChallenges from "@/ui/icons/TotalChallenges";
import SectionDescription from "../../components/SectionDescription";
import { useUser } from "@/context/UserContext";
import SadFaceIcon from "/assets/icons/sad-face.svg";
import Dialog from "@/components/Dialog";
import { useNavigate } from "react-router-dom";
import { ENABLE_POINTS_UI } from "@/utils/feature-flags";

function Challenges() {
  const {
    submittedChallenges,
    totalChallenges,
    setExpandedIndexes,
    getIsOpenAccordion,

    challengesPerStage,
    updateChallengePerStage,
  } = useChallenges();
  const { userInfo } = useUser();
  const { stages, isLoading, isUserOutOfReality } = useStages();
  const navigate = useNavigate();

  if (!userInfo) return null;

  if (isUserOutOfReality === true)
    return (
      <Dialog
        isOpen={true}
        icon={<img src={SadFaceIcon} />}
        text="Infelizmente não foi dessa vez. Você não avançou para a próxima etapa. Mas não deixe de tentar na próxima edição."
        confirmButtonText="Voltar"
        onConfirm={async () => {
          navigate(-1);
        }}
      />
    );

  return (
    <div>
      <SectionDescription
        title="COMPLETE OS DESAFIOS"
        description={
          ENABLE_POINTS_UI
            ? "Mestre, aqui você deverá {{completar}} os desafios disponíveis para {{conquistar}} mais {{pontos}}. Clique em {{'Iniciar desafio'}} para começar. Leia as orientações de cada desafio com atenção!"
            : "Queremos te conhecer melhor! Para finalizar a sua inscrição, você precisa concluir os 6 desafios disponíveis.\nClique em {{\"Iniciar desafio\"}} e leia atentamente as orientações de cada etapa.\n\n⚠️ Após o envio, não será possível substituir os arquivos. Revise antes de concluir."
        }
      />

      <CardWithShadow mt="1.5rem" py="1rem">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          px="1.5rem"
        >
          <Text color={Theme.colors.icon.default}>Lista de Desafios</Text>

          <Box
            display="flex"
            border={`1px solid ${Theme.colors.neutral.light}`}
            p="0.5rem"
            alignItems="center"
            borderRadius="0.5rem"
          >
            <TotalChallenges />

            <Text ml="0.5rem" color={Theme.colors.text.secondary}>
              Total enviados:{" "}
            </Text>
            <Text color={Theme.colors.text.primary}>
              {submittedChallenges}/{totalChallenges}
            </Text>
          </Box>
        </Box>

        <Spacer height="1rem" />
        <Box px={{ xs: "0px", sm: "2rem" }}>
          {isLoading && (
            <Box display="flex" justifyContent="center" p="1rem">
              <CircularProgress size="1rem" />
            </Box>
          )}
          <ShapedAccordion
            onChangeExpanded={setExpandedIndexes}
            items={
              stages.map((item, index) => ({
                summary: (
                  <AccordionSummary
                    stepNumber={index + 1}
                    title={item.subTitle}
                    totalComplete={
                      item.submittedChallenges ?? item.completedChallenges
                    }
                  />
                ),
                details: (
                  <AccordionDetailsList
                    stageId={item.id}
                    isOpen={getIsOpenAccordion(index)}
                    onChangeChallengesAmount={(val) =>
                      updateChallengePerStage(item.id, val)
                    }
                  />
                ),
                hidden: challengesPerStage[item.id] === 0,
              })) ?? []
            }
            fixedIndex={(stages?.length ?? 0) - 1}
          />
        </Box>
      </CardWithShadow>
    </div>
  );
}

export default Challenges;
